// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1cLWc","mobileMenu":"Footer_mobileMenu__1guoh","footerLogo":"Footer_footerLogo__3OPWs","footerContainer":"Footer_footerContainer__1jjfv"};